import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=a495a180&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a495a180')) {
      api.createRecord('a495a180', component.options)
    } else {
      api.reload('a495a180', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=a495a180&", function () {
      api.rerender('a495a180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FKAOR5F2LF4j/JS/comp/ErrorMessage.vue"
export default component.exports